import React from 'react'
import CommonService from '../../services/commonService'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
  }

  // This lifecycle is invoked after an error has been thrown by a descendant component.
  componentDidCatch(error) {
    this.CommonService.AddErrorLog(error.message, error.stack)
  }

  render() {
    const { children } = this.props
    return children
  }
}

export default ErrorBoundary
